import { CalendarBlank } from "@phosphor-icons/react";

/** Resident ticks preferred AM / PM slots over the next two weeks; the office confirms one later. */
export default function SlotPicker({ slots, value, onChange, accent, max = 6 }) {
  if (!slots?.length) return null;
  const has = (d, p) => value.some(s => s.date === d && s.period === p);
  const toggle = (d, p) => {
    if (has(d, p)) return onChange(value.filter(s => !(s.date === d && s.period === p)));
    if (value.length >= max) return;
    onChange([...value, { date: d, period: p }]);
  };
  return (
    <div className="space-y-2" data-testid="slot-picker">
      <h2 className="text-xs font-semibold tracking-wider text-slate-500 uppercase flex items-center gap-1"><CalendarBlank className="h-3.5 w-3.5" /> When could we visit? (optional)</h2>
      <p className="text-xs text-slate-500">Tick up to {max} slots that suit you — AM is 8am–12pm, PM is 12pm–5pm. We'll confirm one with you.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
        {slots.map(d => (
          <div key={d.date} className="flex items-center gap-1.5 rounded-md border border-border px-2 py-1.5 bg-background">
            <span className="text-xs font-medium w-24 shrink-0">{d.label}</span>
            {d.periods.map(p => {
              const on = has(d.date, p);
              return (
                <button key={p} type="button" onClick={() => toggle(d.date, p)}
                        className={`flex-1 text-xs py-1 rounded-full border transition ${on ? "text-white border-transparent" : "border-border hover:bg-muted/40"}`}
                        style={on ? { backgroundColor: accent } : undefined}
                        data-testid={`slot-${d.date}-${p}`}>{p}</button>
              );
            })}
          </div>
        ))}
      </div>
      {value.length > 0 && <p className="text-xs text-slate-600 dark:text-slate-300" data-testid="slot-summary">{value.length} slot{value.length === 1 ? "" : "s"} chosen</p>}
    </div>
  );
}
